import { Button } from '@/components/ui/button'
export function AffiliateHero() {
	return (
		<div className='relative flex flex-col overflow-hidden rounded-[14px] border border-border bg-secondary lg:flex-row lg:items-center'>
			<div className='pointer-events-none absolute -right-24 -top-40 h-[600px] w-[600px] rounded-full opacity-70 blur-[140px]' style={{ background: 'hsl(var(--info))' }} />

			<div className='relative z-10 flex flex-col items-start gap-10 p-6 sm:p-12 lg:max-w-[726px]'>
				<div className='flex flex-col items-start gap-4'>
					<span className='rounded-[34px] bg-primary/[0.08] px-3.5 py-1.5 text-sm font-medium tracking-[-0.21px] text-primary'>Referral Program</span>
					<h1 className='text-4xl font-extrabold leading-[136%] tracking-[-0.24px] sm:text-5xl'>
						<span className='text-foreground'>Invite Friends to Earn</span>
						<br />
						<span className='whitespace-nowrap bg-gradient-to-r from-[hsl(var(--accent-blue))] to-[hsl(var(--accent-green))] bg-clip-text text-transparent'>
							1000 BECY + 25% Commission
						</span>
					</h1>
				</div>

				<Button variant='primary' className='w-25 h-12 sm:w-40 lg:w-60'>
					Sign up &amp; Earn
				</Button>
			</div>

			<img src='/images/affiliate/affiliate_model.png' alt='' className='pointer-events-none absolute right-0 top-0 z-0 hidden h-[110%] object-contain sm:block' />
		</div>
	)
}
